import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-font-icon',
  templateUrl: './font-icon.component.html',
  styleUrls: ['./font-icon.component.scss']
})
export class FontIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
